import React, { ReactNode, useMemo } from 'react';
import { AppShellTemplate } from '@experiences/templates/app-shell-template';
import { ShellChromeProvider } from '@experiences/templates/shell-chrome-context';
import { useSalesPortalSidebarNav } from '@/experiences/sales-portal/blocs/hooks/use-sales-portal-sidebar-nav';
import { useSidebarToggleLeadingAction } from '@experiences/templates/use-sidebar-toggle-leading-action';

interface SalesHubShellTemplateProps {
  children: ReactNode;
  sidebarWidth?: number;
}

/**
 * {@link AppShellTemplate} bound to the Sales Hub. Publishes the sidebar toggle
 * to {@link ShellChromeProvider} so screens' `AppPageLayout` picks it up without
 * each wiring the toggle itself.
 */
export const SalesHubShellTemplate: React.FC<SalesHubShellTemplateProps> = ({
  children,
  sidebarWidth,
}) => {
  const { loading, navItems } = useSalesPortalSidebarNav();
  const leadingAction = useSidebarToggleLeadingAction();
  const chrome = useMemo(() => ({ leadingAction }), [leadingAction]);

  return (
    <AppShellTemplate
      navItems={navItems}
      navItemsLoading={loading}
      sidebarWidth={sidebarWidth}
    >
      <ShellChromeProvider value={chrome}>{children}</ShellChromeProvider>
    </AppShellTemplate>
  );
};
